module.exports = __webpack_public_path__ + "img/marketea_azul.8947c0d1.svg";